import { BENEFIT_TYPE_DENTAL } from '@hixme/benefit-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { connectWaiter, getWaiter } from 'redux-waiter'
import { getClientBenefits } from 'modules/api/client-benefits-get'

// project
import { clearModal } from '@hixme/modal'
import DeclineCoverageModal from 'components/DeclineCoverageModal'

// project
import { createErrorNotification } from 'modules/notification-manager/actions'

// store
import cart from 'store/modules/cart'
import person from 'store/modules/persons'
import userSession from 'store/modules/user-session'

// module
import { datadog } from 'helpers/datadog'
import { constants } from '../modules/dental-coverage'

// store

// module
import { handleActivityLogPopup } from 'helpers/activityLogHelper'
import withFeatureFlags from 'hocs/withFeatureFlags'
import { logGenericActivity } from 'modules/activity-log/log-generic-activity'
import { ShopForHealthAction } from 'routes/Benefits/HealthBundles/shop-for-health-activity-log/shop-for-health-log'
import { getPersonsSelector } from 'store/modules/persons/selectors'
import { isImpersonating } from 'store/modules/user-session/selectors'

const mapStateToProps = (state, props) => {
  const waiter = getWaiter(state, constants.GET_DENTAL_PLANS)
  const { Person } = getPersonsSelector(state)
  const flags = props?.flags
  const isActivityLogEnabled = flags['enrollme.activity-log-reason-popup-enabled']
  const isImpersonated = isImpersonating(state)
  const isTestUser = Person?.IsTestUser

  return {
    benefitProducts: (waiter.response && waiter.response.ClientBenefits) || [],
    enrollmentKey:
      props.data?.enrollmentPublicKey || userSession.selectors.getEnrollmentPublicKey(state),
    coveredPersons: props.data?.persons
      ? props.data.persons.map((person) => ({ Id: person.personPublicKey }))
      : [
          person.selectors.getPersonSelector(state),
          ...person.selectors.getDependentsEligibleForBenefits(state),
        ],
    isProcessing:
      getWaiter(state, cart.constants.getBenefitPath(BENEFIT_TYPE_DENTAL)).isPending || false,
    isActivityLogEnabled,
    isImpersonated,
    isTestUser,
  }
}

const mapDispatchToProps = (dispatch, _props) => ({
  onDeclineClick: (coveredPersons, [benefit], enrollmentKey, props) => {
    const callback = ({ reason, reasonCategory, zendeskTicket }) => {
      dispatch(
        cart.actions.declineBenefit(
          BENEFIT_TYPE_DENTAL,
          coveredPersons,
          benefit,
          null,
          enrollmentKey
        )
      )
        .then(
          () => {
            logGenericActivity({
              additionalData: {
                coveredPersons,
                benefit: [benefit],
                enrollmentKey,
                reason,
                reasonCategory,
                zendeskTicket,
              },
              activity: 'declined dental coverage',
              action: ShopForHealthAction.DeclineDentalCoverage,
            })
            datadog.declineBenefits(BENEFIT_TYPE_DENTAL, coveredPersons, benefit)
            if (props.data?.enrollmentPublicKey) {
              props.data?.onDecline?.()
            } else {
              dispatch(userSession.actions.pushNextBenefitRoute())
            }
          },
          () => {
            dispatch(
              createErrorNotification('There was an error declining dental. Please try again.')
            )
          }
        )
        .finally(() => dispatch(clearModal()))
    }

    handleActivityLogPopup({
      isImpersonated: props.isImpersonated,
      isTestUser: props.isTestUser,
      isActivityLogEnabled: props.isActivityLogEnabled,
      dispatch,
      contentText: 'Are you sure you want to decline this dental coverage?',
      onSubmit: callback,
    })
  },
})

export default compose(
  withFeatureFlags,
  connect(mapStateToProps, mapDispatchToProps),
  connectWaiter({
    name: constants.GET_DENTAL_PLANS,
    requestCreator: ({ EnrollmentPublicKey, PersonPublicKeys }) =>
      getClientBenefits({
          EnrollmentPublicKey,
          BenefitType: BENEFIT_TYPE_DENTAL,
          PersonPublicKeys,
        }),
    requestOnMountParams: ({ enrollmentKey, coveredPersons }) => {
      const keys = coveredPersons.map((i) => i.Id)
      return {
        EnrollmentPublicKey: enrollmentKey,
        PersonPublicKeys: keys,
      }
    },
  })
)(DeclineCoverageModal)
